import React from "react";
import { Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";

function BlogCategoryPost({ Blogs }) {
  return (
    <div>
      <Scrollbars autoHide autoHeight autoHeightMax={400}>
        {Blogs.map((post) => {
          const { id, heading, blogImage, content, date , catagory} = post;
          return (
            <NavLink
              className="recentBlogNavLink"
              key={id}
              to={`/blog/${post.title}`}
            >
              <Card className="recentBlogCard">
                <Card.Img
                  className="recentBlogImage"
                  variant="top"
                  src={blogImage}
                />
                <Card.Body style={{ padding: "0px" }}>
                  <Card.Title className="recentBlogTitle">{heading}</Card.Title>
                  <Card.Footer>
                    <small className="text-muted recentPostedOn">{date}</small>
                  </Card.Footer>
                </Card.Body>
              </Card>
            </NavLink>
          );
        })}
      </Scrollbars>
    </div>
  );
}

export default BlogCategoryPost;
